module.exports = __webpack_public_path__ + "static/gordon-6adf74ba00c4560567e06a89a8af59fe.png";